import { createSelector } from '@reduxjs/toolkit';

const appState = state => state.appState;

export const getSelectedTnTTrailer = createSelector(appState, state => state?.selectedTnTTrailer || {});
export const getSelectedTnTTrailerAssetId = createSelector(appState, state => state?.selectedTnTTrailer?.assetId);
